import i18next from "i18next";
import { messageCodes,messageCodesFrontEnd } from "./messageCodes";

export const translateValidationMessage = (text: string) => {
  return i18next.t(text);
};

export const translateAPIMessage = (code: number, attribute?: { [key: string]: string }) => {
  const key = messageCodes[code];
  if (key) {
    return i18next.t(key, attribute ? attribute : {});
  }

  return "";
};

export const translateFrontEndAlerts = (code: number) => {
  const key = messageCodesFrontEnd[code];

  if (key) return i18next.t(key);
  return "";
};
